export const normalizeConsentRenewInfo = (rawData) => {
  return {
    actionType: rawData?.action_type ?? '', // 'SHOW_POPUP' | 'NONE'
    info: normalizeInfo(rawData?.info) ?? {},
  }
}

export const normalizeInfo = (rawData) => {
  return {
    id: rawData?.id ?? 0,
    productName: rawData?.product_name ?? '',
    price: rawData?.price ?? '',
    newPrice: rawData?.new_price ?? '',
    startDate: rawData?.start_date ?? '',
    dueDate: rawData?.due_date ?? '',
    isConsentDisagree: rawData?.is_consent_disagree ?? false,
    isDoubleSlimEarly: rawData?.is_double_slim_early ?? false,
  }
}
